export default __webpack_public_path__ + "static/media/moj.d36ac17a.png";